import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_BASE });

export function initiateCall(data) {
  return api.post('/calls/initiate', data);
}

export function bulkInitiateCalls(data) {
  return api.post('/calls/bulk-initiate', data);
}

export function getCalls(params = {}) {
  return api.get('/calls', { params });
}

export function getCallById(id) {
  return api.get(`/calls/${id}`);
}

export function getCallEvents(id) {
  return api.get(`/calls/${id}/events`);
}

export function getStats() {
  return api.get('/calls/stats');
}

export default api;
